import React
	from "react";
import {
	Route,
	Router,
	Switch
} from "react-router-dom";
import history
	from "./history";
import HeaderView
	from "../views/layout/HeaderView";
import ContentView
	from "../views/layout/ContentView";
export default function AppRouter() {
	return (
			<Router history={history}>
				<HeaderView />
				<Switch>
					<Route path='/lists' render={() =>
						<ContentView section="lists" />}>
					</Route>
					<Route path='/practices'>
						<ContentView section="practices" />
					</Route>
					<Route path='/rules'>
						<ContentView section="rules" />
					</Route>
					<Route path='/contact'>
						<ContentView section="contact" />
					</Route>
					<Route path='/search'>
						<ContentView section="search" />
					</Route>
					<Route path='/contact'>
						<ContentView section="contact" />
					</Route>
					<Route path='/'>
						<ContentView section="home" />
					</Route>
				</Switch>
			</Router>
	)
}